import React, { Fragment, useEffect, useState } from 'react';
import {Box} from '@mui/material';
import styled from '@emotion/styled';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import Colors from 'assets/Style/Colors';
import { useAuth } from 'context/UseContext';
import Storage from 'utils/Storage';
import { useAuthString } from 'auth/useAuthStorage';


const useStyle = makeStyles({
    step: {
        flex: 1,
        display: 'flex',
        gap: '20px',
        alignItem: 'center',
        justifyContent: 'space-between',
        '& .MuiStepLabel-label': {
            color: `${Colors.charcoalGrey} !important`,
            fontSize: { md: '16px' }
        }
    }
})

const StepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: Colors.iron,
    zIndex: 1,
    color: Colors.charcoalGrey,
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    "svg": {
        width: 'auto',
        height: '25px',
        "path": {
            fill: Colors.smokeyGrey
        },
    },
}));


function RiazMuhammad() {

    const classes = useStyle();
    const navigate = useNavigate();
    const [renderState, setRenderState] = useState()
    const { user } = useAuth();
    const { getStorageItem } = Storage();
    const METABASE_SITE_URL = "https://analytics.galaxyshipping.com";
    const dashboardPermission = process.env.REACT_APP_METABASE_IS_ENABLED;

    const riazMuhammadReport = useAuthString('riazMuhammadReport');
    let iframeUrl = METABASE_SITE_URL + "/embed/dashboard/" + riazMuhammadReport + "#bordered=false&titled=true";

    useEffect(() => {
        if (riazMuhammadReport) {
            setRenderState(riazMuhammadReport)
        }

    }, [riazMuhammadReport])
    return (
        <Fragment>
           {
                           dashboardPermission === "true" ? (
                               <>
           
                                   {user?.user_type != 'C' && (
                                       <Box sx={{ height: '100vh' }}><iframe
                                           src={iframeUrl}
                                           frameBorder={0}
                                           width={'100%'}
                                           height={'100%'}
                                           allowTransparency
                                       />
                                       </Box>
           
                                   )}
           
                               </>
                           ) : (
                               <></>
                           )
                       }

        </Fragment>);
}

export default RiazMuhammad;
